import React from 'react';

const GlobalPropsContext = React.createContext('global');

export { GlobalPropsContext };
